import { defineComponent, onMounted, watch } from 'vue';
import ActSetAccessPeriodsCode from '@/presentation/components/act-access-modal/act-set-access-periods/act-set-access-periods.code';
import { MultiSelect } from '@studyportals/multiselect';

export default defineComponent({
	components: {MultiSelect},
	setup: () => {
		const code = new ActSetAccessPeriodsCode();

		onMounted(code.prefillDatePickers.bind(code));
		watch(code.sameDatesPerDashboard, code.prefillDatePickers.bind(code));

		return {
			dateTypeStart: code.dateTypeStart,
			dateTypeEnd: code.dateTypeEnd,
			sameDatesPerDashboard: code.sameDatesPerDashboard,
			actDashboardsToShowDatesFor: code.actDashboardsToShowDatesFor,
			datePickerStart: code.datePickerStart,
			datePickerEnd: code.datePickerEnd,
			setDatePickerRef: code.setDatePickerRef.bind(code),
			retrieveAccessPeriodsValidationIssueForDashboard: code.retrieveAccessPeriodsValidationIssueForDashboard.bind(code),
			handleCheckboxClick: code.handleCheckboxClick.bind(code),
			handleDateSet: code.handleDateSet.bind(code)
		};
	}
});
